export default "//static.tradera.net/touchweb/static/output/images/network-tt.fd12d63e.svg";